import ActiveLeadsCard from './ActiveLeadsCard.component';

export default ActiveLeadsCard;
